import { render, staticRenderFns } from "./CallPod.vue?vue&type=template&id=683b9620&scoped=true"
import script from "./CallPod.vue?vue&type=script&lang=js"
export * from "./CallPod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683b9620",
  null
  
)

export default component.exports